import { render, staticRenderFns } from "./alt-heading.vue?vue&type=template&id=3d327dec"
import script from "./alt-heading.vue?vue&type=script&lang=js"
export * from "./alt-heading.vue?vue&type=script&lang=js"
import style0 from "./alt-heading.vue?vue&type=style&index=0&id=3d327dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports